import { PeriodSelection } from './period-selection.enum';
import { ITime } from '../time-control/w-clock/w-clock.component';

export class Period {
  public period: PeriodSelection = PeriodSelection.OneHour;
  public fromDate = new Date(new Date().getTime() - 3600000);
  public fromTime: ITime = { hour: 0, minute: 0, meriden: 'AM', format: 24 };
  public toDate = new Date();
  public toTime: ITime = { hour: 23, minute: 59, meriden: 'PM', format: 24 };
}
